import React from 'react';
import { Field } from 'redux-form'
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import ActionDelete from 'material-ui/svg-icons/action/delete';
import MenuItem from 'material-ui/MenuItem';

import IconButton from 'material-ui/IconButton';

import FormAutoComplete2 from './FormAutoComplete2'
import FormSelect from './FormSelect'
import FormText from './FormText'
import FormDatePicker from './FormDatePicker'

import * as colors from 'material-ui/styles/colors';

import * as commons from '../commons';

const moment = require('moment');

const style = {
  margin: 0,
  top: 'auto',
  right: 20,
  bottom: 20,
  left: 'auto',
  position: 'fixed',
};

class FormSubHolidayContents extends  React.Component {

  constructor(props) {
    super(props);
    this.state = {
      lineColorList: []
    };
  }

  // getLineColor = (workHolidayAll, subHoliday1, subHoliday2, changeMoney, isAdmin) => {
  getLineColor = (workHolidayAll, subHoliday1, subHoliday2, changeMoneyComplete, isAdmin) => {

    let mode = 0
    if (workHolidayAll) {
      mode = 2
    } else {
      mode = 1
    }

    if (subHoliday1) {
      mode = mode - 1
    }

    if (subHoliday2) {
      mode = mode - 1
    }

    // if (changeMoney) {
    //   if (changeMoney == 4) {
    //     mode = mode - 1
    //   }
    //   if (changeMoney == 8) {
    //     mode = mode - 8
    //   }
    // }

    if (changeMoneyComplete) {
      return colors.grey300
    }

    if (mode <= 0) {
       return colors.grey300
    } else {
        if (isAdmin) {
            return colors.blue100
        } else {
            return colors.white
        }

    }

  }

  clearDate = (index, fields, fieldName) => {
    if (window.confirm("日付をクリアします。よろしいですか？")) {
      let field = fields.get(index)
      field[fieldName] = "";
      fields.insert(field)
      // this.setLineColorState(index, field.workHolidayAll, field.subHoliday1, field.subHoliday2, field.changeMoney, field.changeMoneyComplete)
      this.setLineColorState(index, field.workHolidayAll, field.subHoliday1, field.subHoliday2, field.changeMoneyComplete)
    }
  }

  // setLineColorState = (index, workHolidayAll, subHoliday1, subHoliday2, changeMoney, changeMoneyComplete) => {
  setLineColorState = (index, workHolidayAll, subHoliday1, subHoliday2, changeMoneyComplete) => {

    // const color = this.getLineColor(workHolidayAll, subHoliday1, subHoliday2, changeMoney, changeMoneyComplete)
    const color = this.getLineColor(workHolidayAll, subHoliday1, subHoliday2, changeMoneyComplete)
    let lineColorList = this.state.lineColorList
    lineColorList[index] = color

    this.setState(Object.assign(this.state, { lineColorList: lineColorList }));

  }

  render() {

    const {
      auth,
      fields,
      minDate,
      maxDate,
      dialogMonth,
      onRemoveDate
    } = this.props

    return (
      <div style={{marginBottom: 20}}>

        <div className="row">

          {fields.map((name, index) => {

            const field = fields.get(index)
              let bgColor
              if (field.isAdmin) {
                  bgColor = this.getLineColor(field.workHolidayAll, field.subHoliday1, field.subHoliday2, field.changeMoneyComplete, field.isAdmin)
              } else {
                  bgColor = this.state.lineColorList[index] ||
                      this.getLineColor(field.workHolidayAll, field.subHoliday1, field.subHoliday2, field.changeMoneyComplete, field.isAdmin)
              }

            return (
              <div className="col-12" key={index} >
                <div className="row" style={{backgroundColor: bgColor}}>

                  <div className="col-2">
                    <Field 
                    key={index}
                    name={`${name}.workHolidayAll`} 
                    component={FormDatePicker} 
                    style={{ width: '100%' }}
                    textFieldStyle={{width: '100%'}}
                    dialogMonth={dialogMonth}
                    minDate={minDate}
                    maxDate={maxDate}
                    disableYearSelection
                    disabled={field.isAdmin ? false : true}
                    inputStyle={{color: colors.grey800}}
                    floatingLabelStyle={{color: colors.grey600}}
                    floatingLabelFixed
                    floatingLabelText="休出(全日)"
                    underlineStyle={{borderColor: colors.grey500}}
                    showWeek/>
                  </div>

                  <div className="col-2">
                    <Field 
                    key={index}
                    name={`${name}.workHolidayHarf`} 
                    component={FormDatePicker} 
                    style={{ width: '100%' }}
                    textFieldStyle={{width: '100%'}} 
                    dialogMonth={dialogMonth} 
                    minDate={minDate}
                    maxDate={maxDate}
                    disableYearSelection
                    disabled={field.isAdmin ? false : true}
                    inputStyle={{color: colors.grey800}}
                    floatingLabelStyle={{color: colors.grey600}}
                    floatingLabelFixed
                    floatingLabelText="休出(半日)"
                    underlineStyle={{borderColor: colors.grey500}}
                    showWeek/>
                  </div>

                  <div className="col-2">
                    <Field
                      key={index}
                      name={`${name}.subHoliday1`}
                      component={FormDatePicker}
                      style={{width: '100%'}}
                      textFieldStyle={{width: '100%'}}
                      dialogMonth={dialogMonth}
                      minDate={minDate}
                      maxDate={maxDate}
                      disableYearSelection
                      inputStyle={{color: colors.grey800}}
                      floatingLabelStyle={{color: colors.grey600}}
                      onChange={(e) => {
                        const field = fields.get(index)
                        // this.setLineColorState(index, field.workHolidayAll, 'change', field.subHoliday2, field.changeMoney, field.changeMoneyComplete)
                        this.setLineColorState(index, field.workHolidayAll, 'change', field.subHoliday2, field.changeMoneyComplete)
                      }}
                      onDismiss={this.clearDate.bind(this, index, fields, 'subHoliday1')}
                      floatingLabelFixed
                      floatingLabelText="代休(半日1)"
                      underlineStyle={{borderColor: colors.grey500}}
                      showWeek/>

                  </div>

                  <div className="col-2">
                    <Field
                      key={index}
                      name={`${name}.subHoliday2`}
                      component={FormDatePicker}
                      style={{width: '100%'}}
                      textFieldStyle={{width: '100%'}}
                      dialogMonth={dialogMonth}
                      minDate={minDate}
                      maxDate={maxDate}
                      disableYearSelection
                      inputStyle={{color: colors.grey800}}
                      floatingLabelStyle={{color: colors.grey600}}
                      onChange={() => {
                        const field = fields.get(index)
                        // this.setLineColorState(index, field.workHolidayAll, field.subHoliday1, 'change', field.changeMoney, field.changeMoneyComplete)
                        this.setLineColorState(index, field.workHolidayAll, field.subHoliday1, 'change', field.changeMoneyComplete)
                      }}
                      onDismiss={this.clearDate.bind(this, index, fields, 'subHoliday2')}
                      floatingLabelFixed
                      floatingLabelText="代休(半日2)"
                      underlineStyle={{borderColor: colors.grey500}}
                      showWeek/>
                  </div>
{/* 
                  <div className="col-2">

                    <Field
                      name={`${name}.changeMoney`}
                      component={FormSelect}
                      style={{ width: '100%' }}
                      inputStyle={{color: colors.grey800}}
                      floatingLabelStyle={{color: colors.grey600}}
                      floatingLabelFixed
                      floatingLabelText="時間振替"
                      underlineStyle={{borderColor: colors.grey500}}
                      iconStyle={{fill: colors.grey500}}
                      onChange={(e, key, payload) => {
                        const field = fields.get(index)
                        this.setLineColorState(index, field.workHolidayAll, field.subHoliday1, field.subHoliday2, key)
                      }}
                    >
                      <MenuItem value="" primaryText={''} />
                      <MenuItem value={4} primaryText={'4'} />
                      <MenuItem value={8} primaryText={'8'} />
                    </Field>

                  </div> */}

                  <div className="col-2">

                    <Field
                      name={`${name}.changeMoneyComplete`}
                      component={FormSelect}
                      style={{ width: '100%' }}
                      inputStyle={{color: colors.grey800}}
                      floatingLabelStyle={{color: colors.grey600}}
                      floatingLabelFixed
                      floatingLabelText="時間振替"
                      underlineStyle={{borderColor: colors.grey500}}
                      iconStyle={{fill: colors.grey500}}
                      onChange={(e, key, payload) => {
                        const field = fields.get(index)
                        this.setLineColorState(index, field.workHolidayAll, field.subHoliday1, field.subHoliday2, key)
                      }}
                    >
                      <MenuItem value="" primaryText={''} />
                      <MenuItem value={1} primaryText={'完了'} />
                    </Field>

                  </div>

                  <div className="col-2">
                    <Field name={`${name}.comment`}
                           component={FormText}
                           inputStyle={{color: colors.grey800}}
                           floatingLabelStyle={{color: colors.grey600}}
                           floatingLabelFixed
                           floatingLabelText="備考"
                           underlineStyle={{borderColor: colors.grey500}}
                           style={{ width: '100%' }} />
                  </div>

                </div>

              </div>
            )

          })}

        </div>

          {
              auth.user.permission == 2 && (
                  <div className="row">

                      <div className="col-11" ></div>

                      <div className="col-1" style={{ marginTop: 10 }}>
                          <div style={{ display: 'flex', flexDirection: 'column',justifyContent: 'center', alignItems: 'center', height: '100%', paddingTop: '5px' }}>
                              <FloatingActionButton zDepth={0} mini={true} backgroundColor={colors.grey400}
                                                    onClick={() => {
                                                        fields.push({
                                                            isAdmin: 1,
                                                        })
                                                    }}>
                                  <ContentAdd />
                              </FloatingActionButton>
                          </div>
                      </div>
                  </div>
              )
          }
      </div>

    )

  }

}

export default FormSubHolidayContents


// WEBPACK FOOTER //
// ./src/components/FormSubHolidayContents.js